import React, { useEffect, useState } from "react";

import Container from "../container";
import NumberInput from "../number-input";
import StyledRowContainer, {
    StyledRowContainerItem,
    StyledRowError
} from "../styled/row-container";

import { iControlProps } from "../../types";

type SortCodeProps = iControlProps & {
    id: string;
    type: string;
    isRequired?: string;
    error?: string;
    errorMessage?: string;
    customTooltip?: string;
    field_sort_code_jurisdiction?: string;
};

const containerItemProps = {
    className: "u-width-input-60px u-text-input-centre u-mr-3",
    style: { width: "auto" }
};

const SortCode = ({
    id,
    value = "",
    isRequired,
    errorMessage,
    onChange,
    field_sort_code_jurisdiction = "roi",
    ...props
}: SortCodeProps) => {
    const values: Array<string> = value.split("-");
    const [error, setError] = useState("");
    const [sortCode1] = useState("90");
    const [sortCode2, setSortCode2] = useState(values[1] || "");
    const [sortCode3, setSortCode3] = useState(values[2] || "");
    let sortCodeInput3: HTMLInputElement;

    const updateSortCode = () => {
        onChange &&
            onChange(
                ((sortCode2 || sortCode3) &&
                    sortCode1 + "-" + sortCode2 + "-" + sortCode3) ||
                    undefined
            );
    };

    useEffect(updateSortCode, [sortCode2, sortCode3]);

    const updateError = () => setError(props.error || "");
    useEffect(updateError, [value]);

    return (
        <Container
            id={id}
            type={props.type}
            isRequired={isRequired}
            label={props.label}
            cssClass={props.cssClass}
            description={props.description}
            customTooltip={props.customTooltip}
        >
            {/* 
            // @ts-ignore */}
            <StyledRowContainer data-id={id} justifyContent="flex-start">
                <StyledRowContainerItem {...containerItemProps}>
                    <NumberInput
                        id={id ? `${id}_1` : ""}
                        cssClass="integer-only keep-leading-zeros"
                        required={isRequired}
                        value={sortCode1}
                        readOnly={true}
                        aria-label="Sort code first two digits"
                    />
                </StyledRowContainerItem>
                <StyledRowContainerItem {...containerItemProps}>
                    <NumberInput
                        id={id ? `${id}_2` : ""}
                        cssClass="integer-only keep-leading-zeros"
                        className={error ? "u-border-color-alert" : ""}
                        required={isRequired}
                        value={sortCode2}
                        onChange={(value: string) => {
                            if (value.length <= 2) {
                                setSortCode2(value);
                            }
                            value.length === 2 &&
                                sortCodeInput3 &&
                                sortCodeInput3.focus();
                        }}
                        aria-label="Sort code middle two digits"
                    />
                </StyledRowContainerItem>
                <StyledRowContainerItem {...containerItemProps}>
                    <NumberInput
                        id={id ? `${id}_3` : ""}
                        cssClass="integer-only keep-leading-zeros"
                        className={error ? "u-border-color-alert" : ""}
                        required={isRequired}
                        value={sortCode3}
                        innerRef={(input: HTMLInputElement) => {
                            sortCodeInput3 = input;
                        }}
                        onChange={(value: string) => {
                            if (value.length <= 2) {
                                setSortCode3(value);
                            }
                        }}
                        aria-label="Sort code last two digits"
                    />
                </StyledRowContainerItem>
            </StyledRowContainer>
            <StyledRowError className="field-error">{error}</StyledRowError>
        </Container>
    );
};

export default SortCode;
